import { Component, Input } from '@angular/core';

/**
 * A child of a social posts carousel/slider component, representing a card.
 * ng-bootstrap tooltips are bound to this component.
 */
@Component({
  selector: 'app-social-card',
  templateUrl: './social-card.component.html',
  styleUrls: ['./social-card.component.scss']
})
export class SocialCardComponent {
  @Input() public blurb: string;
  @Input() public imageUrl: string;
  @Input() public targetUrl: string;
  @Input() public iconClass: string;
}
